import { render, staticRenderFns } from "./businessnodes_detail.vue?vue&type=template&id=2054467b"
import script from "./businessnodes_detail.vue?vue&type=script&lang=js"
export * from "./businessnodes_detail.vue?vue&type=script&lang=js"
import style0 from "./businessnodes_detail.vue?vue&type=style&index=0&id=2054467b&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports